import { CuentaContable } from "./cuenta-contable";

export class TipoCuenta{
    public constructor(
        public id: string = "",
        public nombre:string = "",
        public is_activo: boolean = false,
        public empresa_id: string = "",
        public usuario_id:string = null,

        public cuentas:Array<CuentaContable> = [],


    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/tipo-cuenta.ts